import _ from "lodash";
import { DatePicker, Table, TableColumnsType } from "antd";
import Button from "../../../Button";
import FinancialDatePicker from "../FinancialDatePicker";
import SelectCampus from "../../../SelectCampus";
import SelectCampusMultiChoice from "../../../SelectCampusMultiChoice";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { useEffect, useState } from "react";
import { DateTableType } from "../../../../constans";
import moment from "moment";
import { ICashFlow, ICashFlowExpense, ICashFlowIncome, ICashFlowPnL, IGetCashFlowExpense, IGetCashFlowIncome, IGetCashFlowPnL } from "../../../../models/financials.model";
import useAxios from "../../../../hooks/useAxios";
import { getCashFlowExpense, getCashFlowIncomesCampus, getCashFlowIncomesHq, getCashFlowPnL } from "../../../../api/financials.api";
import DownloadButton from "../../../DownloadButton";
import { getCommonCodeLabel } from "../../../../lib/store";
import exportMultiTitleTable from "../../../../lib/exportMultiTitleTable";
import Loader from "../../../Loader";
import styled from "styled-components";

const Block = styled.div`
    .comm-table__area.table-cash-flow .btn-unfold {
        width: 20px;
        height: 20px;
        border:1px solid #2e4052;
        border-radius: 50%;
        position: absolute;
        right:20px;
    }

    .comm-table__area.table-cash-flow .btn-unfold::before {
        content:'';
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        margin:0 auto;
        display: block;
        width:10px;
        height:2px;
        background-color: #2e4052;
        border-radius: 10px;
    }

    .comm-table__area.table-cash-flow .btn-unfold::after {
        content: "";
        position: absolute;
        display: block;
        width: 10px;
        height: 2px;
        border-radius: 12px;
        background-color: #2e4052;
        right: 5px;
        top: 8px;
        transition: all 0.3s;
        transform: rotate(90deg) translateY(-50%);
    }

    .comm-table__area.table-cash-flow .btn-unfold.fold::after {
        transition: all 0.3s;
        transform: translateY(-50%);
        transition: 0.3s;
        opacity: 0;
    }

    .comm-table__area .cashflowBorderRight {
        border-right: 2px solid #eaecee !important;
    }

    .comm-table__area .cashflowBorderBottom td {
        border-bottom: 2px solid #eaecee;
    }

    .comm-table__area tbody tr:nth-child(1) td.cashflowCsType {
        border-bottom: 2px solid #eaecee;
    }
`;

const CashFlowList = () => {
    const { t, i18n } = useTranslation();
    const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
    const { campusData } = useSelector((state: RootState) => state.campusData);

    const [campusCodes, setCampusCodes] = useState<string[]>([]);
    const [srtDate, setSrtDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [defSelType, setDefSelType] = useState<number>(0);
    const [incomeRefineCampus, setIncomeRefineCampus] = useState<ICashFlowIncome[]>([]);
    const [incomeRefineHq, setIncomeRefineHq] = useState<ICashFlowIncome[]>([]);
    const [expenseRefine, setExpenseRefine] = useState<ICashFlowExpense[]>([]);
    const [cashFlowPnLRefine1, setCashFlowPnLRefine1] = useState<ICashFlowPnL[]>([]);
    const [cashFlowPnLRefine2, setCashFlowPnLRefine2] = useState<ICashFlowPnL[]>([]);
    const [cashFlowPnLInCnt1, setCashFlowPnLInCnt1] = useState(0);
    const [cashFlowPnLExCnt1, setCashFlowPnLExCnt1] = useState(0);
    const [cashFlowPnLInCnt2, setCashFlowPnLInCnt2] = useState(0);
    const [cashFlowPnLExCnt2, setCashFlowPnLExCnt2] = useState(0);
    const [dateCashFlow, setDateCashFlow] = useState<ICashFlow[]>([]);
    const [totalSales, setTotalSales] = useState(0);    //당월 매출 = 캠퍼스 총매출 합계
    const [dateUnpaid, setDateUnpaid] = useState(0);  //당월 미수금 = 미납액 합계
    const [pnlYear, setPnlYear] = useState('');
    const [pnlNextYear, setPnlNextYear] = useState('');
    const [pnlMode, setPnlMode] = useState(false);

    const {data: incomeCampus, isLoading: isLoading, error: error, execute: executeIncomeCampus } = useAxios<IGetCashFlowIncome>();
    const {data: incomeHq, isLoading: isLoading2, error: error2, execute: executeIncomeHq } = useAxios<IGetCashFlowIncome>();
    const {data: expense, isLoading: isLoading3, error: error3, execute: executeExpense } = useAxios<IGetCashFlowExpense>();
    const {data: cashFlowPnL, isLoading: isLoading4, error: error4, execute: executePnL } = useAxios<IGetCashFlowPnL>();

    useEffect(() => {
        const defaultDate = moment(new Date());
        setSrtDate(moment(defaultDate).format('YYYYMM01'));
        setEndDate(moment(defaultDate).format('YYYYMMDD'));

        setPnlYear(moment(defaultDate).format('YYYY'));
        setPnlNextYear(moment(defaultDate).add(1,'year').format('YYYY'));
    },[]);
    
    useEffect(() => {
        if(incomeCampus) {
            refineSetting(_.cloneDeep(incomeCampus.data), setIncomeRefineCampus, 'C');

            getExpense();   //캠퍼스 매출 확인 이후 지출내역 조회
        }
    }, [incomeCampus]);

    useEffect(() => {
        if(incomeHq) {
            refineSetting(_.cloneDeep(incomeHq.data), setIncomeRefineHq, 'H');
        }
    }, [incomeHq]);

    useEffect(() => {
        if(expense) {
            let tempExpense : ICashFlowExpense[]  = _.cloneDeep(expense.data);

            let tempTotalAmount: number = 0;
            let tempTotalExceptionAmount: number = 0;
            let tempTotalApplyAmount: number = 0;

            //if (tempExpense.length > 0) {
                tempExpense.forEach((item: ICashFlowExpense) => {
                    item.applyAmount = item.expenseAmount - item.exceptionAmount;
                    item.salesRate = (item.expenseAmount / totalSales).toFixed(3);
                    
                    //total
                    tempTotalAmount += item.expenseAmount;
                    tempTotalExceptionAmount += item.exceptionAmount;
                    tempTotalApplyAmount += item.applyAmount;
                });

                //totalSales //당월 매출 = 캠퍼스 총매출 합계    
                //dateUnpaid //당월 미수금 = 미납액 합계   
                //tempTotalApplyAmount //지출 손익반영금액
                const tempNetIncome = totalSales - tempTotalAmount;                 //당월 순이익 = 당월 매출 - 당월 지출
                const tempDateCash = tempNetIncome - dateUnpaid;                    //운용가능현금 = 당월 순이익 - 당월미수금
                const tempDateBalance = tempDateCash - tempTotalExceptionAmount;    //현금흐름잔액 = 운용가능현금 - 손익계산제외금액
                const tempDateIncomeRate = (tempNetIncome === 0) ? '0' : (tempNetIncome / totalSales).toFixed(2); //영업이익율 = 당월순이익/당월매출

                //기간별 현금 흐름 셋팅
                const tempDateCashFlow: ICashFlow[] = [];
                tempDateCashFlow.push({
                    dateSales:totalSales,
                    dateExpense:tempTotalApplyAmount,
                    dateNetIncome:tempNetIncome,
                    dateUnpaid:dateUnpaid,
                    dateCash:tempDateCash,
                    exceptionAmount:tempTotalExceptionAmount,
                    dateBalance:tempDateBalance,
                    incomeRate:tempDateIncomeRate
                });

                setDateCashFlow(tempDateCashFlow);

                tempExpense.push({
                    expenseAccCode: '', detailCodeEngName: '',
                    detailCodeName:t('statistics.appday.column2'), expenseAmount:tempTotalAmount, exceptionAmount:tempTotalExceptionAmount, applyAmount:tempTotalApplyAmount,
                    salesRate: (tempTotalAmount === 0) ? '0' : (tempTotalAmount / totalSales).toFixed(3)
                });
            ///}
            setExpenseRefine(tempExpense);
        }
    }, [expense]);

    useEffect(() => {
        if(cashFlowPnL) {
            let tempPnL : ICashFlowPnL[]  = _.cloneDeep(cashFlowPnL.data);

            if (tempPnL.length > 0) {
                let compareCode = '';
                let compareTotalType = '';
                let tempCount = 0;
                
                let tempPnL1 : ICashFlowPnL[] = []; //계정1Type
                let tempPnL2 : any[] = [];  //계정2Type

                let tempPnLCal : any = {};  //row sum 계산
                tempPnLCal = initPnLRow(tempPnLCal);
                let tempPnLTotal : any = {};    //total row sum 계산
                tempPnLTotal = initPnLRow(tempPnLTotal);

                let tempPnLInCnt1 = 0;
                let tempPnLExCnt1 = 0;
                let tempPnLInCnt2 = 0;
                let tempPnLExCnt2 = 0;

                tempPnL.forEach((item: ICashFlowPnL, index) => {
                    let itemCSType = (item.csType === 'INCOME') ? t('payment.income.tab1') : t('payment.income.tab2');
                    
                    if(tempCount === 0) {
                        //계정1Type
                        compareCode = item.faccCode;
                        compareTotalType = item.csType;
                        //계정2Type 1Depth
                        tempPnL2.push({csType:itemCSType, depth:1, accCodeName:item.faccCodeName});
                        //수입Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt2++ : tempPnLExCnt2++;
                    }

                    if(compareCode !== item.faccCode) {
                        //계정1Type
                        tempPnL1.push(tempPnLCal);
                        //수입/지출 Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt1++ : tempPnLExCnt1++;

                        //계정2Type 소계 추가
                        const tempPnL2Cal = _.cloneDeep(tempPnLCal);
                        tempPnL2Cal.depth = 3;
                        tempPnL2Cal.accCodeName = t('statistics.studentEnrollMonth.column8');
                        tempPnL2.push(tempPnL2Cal);
                        //수입/지출 Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt2++ : tempPnLExCnt2++;

                        tempPnLCal = initPnLRow(tempPnLCal);
                        compareCode = item.faccCode;
                        //compareTotalType = item.csType;

                        //계정1, 2Type 합계 처리
                        if(compareTotalType !== item.csType) {
                            tempPnLTotal.accCodeName = ((compareTotalType === 'INCOME') ? t('payment.income.tab1') : t('payment.income.tab2')) + ' ' + t('cbt.test.column22');
                            tempPnLTotal.depth = 4;
                            tempPnL1.push(tempPnLTotal);
                            tempPnL2.push(tempPnLTotal);
                            //수입/지출 Count
                            if(compareTotalType === 'INCOME') {
                                tempPnLInCnt1++;
                                tempPnLInCnt2++;
                            } else {
                                tempPnLExCnt1++;
                                tempPnLExCnt2++;
                            }
                            tempPnLTotal = initPnLRow(tempPnLTotal);
                            compareCode = item.faccCode;
                            compareTotalType = item.csType;
                        }

                        //계정2Type 1Depth
                        tempPnL2.push({csType:itemCSType, depth:1, accCodeName:item.faccCodeName});
                        //수입/지출 Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt2++ : tempPnLExCnt2++;
                    }
                    tempPnLCal = addPnLRow(tempPnLCal, item);
                    
                    //계정2Type 2Depth
                    const tempPnL2Row = _.cloneDeep(item);
                    tempPnL2Row.depth = 2;
                    tempPnL2Row.csType = itemCSType;
                    tempPnL2Row.accCodeName = item.saccCodeName;
                    tempPnL2Row.total = (item.mo03 + item.mo04 + item.mo05 + item.mo06 + item.mo07 + item.mo08 + item.mo09 + item.mo10 + item.mo11 + item.mo12
                        + item.mo01 + item.mo02);
                    tempPnL2.push(tempPnL2Row);
                    //수입/지출 Count
                    (compareTotalType === 'INCOME') ? tempPnLInCnt2++ : tempPnLExCnt2++;

                    //계정1, 2Type 합계 
                    tempPnLTotal = addPnLRow(tempPnLTotal, item);

                    //마지막 Line 추가
                    if(tempPnL.length === index + 1) {
                        tempPnL1.push(tempPnLCal);
                        //수입/지출 Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt1++ : tempPnLExCnt1++;

                        //계정2Type 소계 추가
                        const tempPnL2Cal = _.cloneDeep(tempPnLCal);
                        tempPnL2Cal.depth = 3;
                        tempPnL2Cal.accCodeName = t('statistics.studentEnrollMonth.column8');
                        tempPnL2Cal.csType = itemCSType;
                        tempPnL2.push(tempPnL2Cal);
                        //수입/지출 Count
                        (compareTotalType === 'INCOME') ? tempPnLInCnt2++ : tempPnLExCnt2++;

                        //합계
                        tempPnLTotal.accCodeName = ((compareTotalType === 'INCOME') ? t('payment.income.tab1') : t('payment.income.tab2')) + ' ' + t('cbt.test.column22');
                        tempPnLTotal.csType = itemCSType;
                        tempPnLTotal.depth = 4;
                        tempPnL1.push(tempPnLTotal);
                        tempPnL2.push(tempPnLTotal);
                        //수입/지출 Count
                        if(compareTotalType === 'INCOME') {
                            tempPnLInCnt1++;
                            tempPnLInCnt2++;
                        } else {
                            tempPnLExCnt1++;
                            tempPnLExCnt2++;
                        }
                    }
                    item.no = tempCount;
                    tempCount++;
                });
                setCashFlowPnLRefine1(tempPnL1);
                setCashFlowPnLRefine2(tempPnL2);
                setCashFlowPnLInCnt1(tempPnLInCnt1);
                setCashFlowPnLExCnt1(tempPnLExCnt1);
                setCashFlowPnLInCnt2(tempPnLInCnt2);
                setCashFlowPnLExCnt2(tempPnLExCnt2);
            }
        }
    }, [cashFlowPnL]);

    const addPnLRow = (tempPnL: ICashFlowPnL, item: ICashFlowPnL) => {
        const tempPnLRow = _.cloneDeep(tempPnL);
        tempPnLRow.csType = item.csType === 'INCOME' ? t('payment.income.tab1') : t('payment.income.tab2');
        tempPnLRow.faccCode = item.faccCode;
        tempPnLRow.faccCodeName = item.faccCodeName;
        tempPnLRow.saccCodeName = item.saccCodeName;
        tempPnLRow.accCodeName = item.faccCodeName;
        tempPnLRow.depth = 2;
        tempPnLRow.mo03 += item.mo03;
        tempPnLRow.mo04 += item.mo04;
        tempPnLRow.mo05 += item.mo05;
        tempPnLRow.mo06 += item.mo06;
        tempPnLRow.mo07 += item.mo07;
        tempPnLRow.mo08 += item.mo08;
        tempPnLRow.mo09 += item.mo09;
        tempPnLRow.mo10 += item.mo10;
        tempPnLRow.mo11 += item.mo11;
        tempPnLRow.mo12 += item.mo12;
        tempPnLRow.mo01 += item.mo01;
        tempPnLRow.mo02 += item.mo02;
        tempPnLRow.total += (item.mo03 + item.mo04 + item.mo05 + item.mo06 + item.mo07 + item.mo08 + item.mo09 + item.mo10 + item.mo11 + item.mo12
             + item.mo01 + item.mo02);
        return tempPnLRow;
    }

    const initPnLRow = (tempPnL: ICashFlowPnL) => {
        const tempPnLRow = _.cloneDeep(tempPnL);
        tempPnLRow.mo03 = 0;
        tempPnLRow.mo04 = 0;
        tempPnLRow.mo05 = 0;
        tempPnLRow.mo06 = 0;
        tempPnLRow.mo07 = 0;
        tempPnLRow.mo08 = 0;
        tempPnLRow.mo09 = 0;
        tempPnLRow.mo10 = 0;
        tempPnLRow.mo11 = 0;
        tempPnLRow.mo12 = 0;
        tempPnLRow.mo01 = 0;
        tempPnLRow.mo02 = 0;   
        tempPnLRow.total = 0;   

        return tempPnLRow;
    }

    const getAllListSearch = () => {
        getIncomeCampus();  //수입 내역(캠퍼스)
        if(auth.hqYn === 'Y') {
            getIncomeHq();  //수입 내역(본사)
        }
        getPnL();   //기간별 영업 손익
    }

    const getIncomeCampus = () => {
        const campusCode = (auth.hqYn === 'Y')
            ? campusCodes
            : currentCampus

        //파라미터 셋팅(form)
        const incomeListParam = new FormData();
        incomeListParam.append('campusCodes', campusCode.toString());
        incomeListParam.append('srtDate', srtDate);
        incomeListParam.append('endDate', endDate);

        executeIncomeCampus(getCashFlowIncomesCampus(incomeListParam));
    }

    const refineSetting = (income:ICashFlowIncome[], setRefineIncome:(param: ICashFlowIncome[]) => void, sType: 'C'|'H') => {
        let tempIncomeList : ICashFlowIncome[]  = income;
        let tempTotalSales: number = 0;
        let tempTotalDiscount: number = 0;
        let tempTotalRefund: number = 0;
        let tempTotalAARefund: number = 0;
        let tempTotalUnpaid: number = 0;
        let tempTotalOnline: number = 0;
        let tempTotalCash: number = 0;
        let tempTotalCard: number = 0;

        if (tempIncomeList.length > 0) {
            tempIncomeList.forEach((item: ICashFlowIncome) => {
                item.paymentTargetCode = getCommonCodeLabel('PA0001',item.paymentTargetCode, i18n.language);

                //total
                tempTotalSales += item.sales;
                tempTotalDiscount += item.discount;
                tempTotalRefund += item.refund;
                tempTotalAARefund += item.aaRefund;
                tempTotalUnpaid += item.unpaid;
                tempTotalOnline += item.online;
                tempTotalCash += item.cash;
                tempTotalCard += item.card;
            });

            tempIncomeList.push({paymentTargetCode:t('statistics.appday.column2'), sales:tempTotalSales, discount:tempTotalDiscount,refund:tempTotalRefund,
                aaRefund:tempTotalAARefund,unpaid:tempTotalUnpaid,online:tempTotalOnline, cash:tempTotalCash, card:tempTotalCard});

            if(sType === 'C') {
                setTotalSales(tempTotalSales);
                setDateUnpaid(tempTotalUnpaid);
            }
        }
        setRefineIncome(tempIncomeList);
    }

    const getIncomeHq = () => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);

        //파라미터 셋팅(form)
        const incomeListParam = new FormData();
        incomeListParam.append('campusCodes', campusCode.toString());
        incomeListParam.append('srtDate', srtDate);
        incomeListParam.append('endDate', endDate);

        executeIncomeHq(getCashFlowIncomesHq(incomeListParam));
    }

    const getExpense = () => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);

        //파라미터 셋팅(form)
        const incomeListParam = new FormData();
        incomeListParam.append('campusCodes', campusCode.toString());
        incomeListParam.append('srtDate', srtDate);
        incomeListParam.append('endDate', endDate);

        executeExpense(getCashFlowExpense(incomeListParam));
    }

    const getPnL = () => {
        const campusCode = auth.hqYn === 'Y'
            ? campusCodes
            : (campusCodes.length ? campusCodes : auth.campus);

        //파라미터 셋팅(form)
        const incomeListParam = new FormData();
        incomeListParam.append('campusCodes', campusCode.toString());
        incomeListParam.append('srtDate', srtDate);
        incomeListParam.append('endDate', endDate);

        executePnL(getCashFlowPnL(incomeListParam));

        setPnlYear(moment(srtDate).format('YYYY'));
        setPnlNextYear(moment(srtDate).add(1,'year').format('YYYY'));
    }

    const inColumns: TableColumnsType<any> = [
        {
            title: t('payment.income.search2'),
            dataIndex: 'paymentTargetCode',
            key: 'paymentTargetCode',
            align: 'center',
        },
        {
            title: t('statistics.sales.title1'),
            dataIndex: 'sales',
            key: 'sales',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        
        {
            title: t('student.student.column39'),
            dataIndex: 'discount',
            key: 'discount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('class.class.column46'),
            dataIndex: 'refund',
            key: 'refund',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('class.class.button7'),
            dataIndex: 'aaRefund',
            key: 'aaRefund',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.column91'),
            dataIndex: 'unpaid',
            key: 'unpaid',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.inex.column4'),
            dataIndex: 'cash',
            key: 'cash',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.record.option2') + '(' + t('entrance.schedule.option4') + ')',
            dataIndex: 'online',
            key: 'online',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('student.student.text6'),
            dataIndex: 'card',
            key: 'card',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
    ];

    const exColumns: TableColumnsType<ICashFlowExpense> = [
        {
            title: t('payment.income.search2'),
            dataIndex: 'detailCodeName',
            key: 'detailCodeName',
            align: 'center',
            render: (value,record) => (<div className='text-left ant-table-cell-ellipsis'>{i18n.language === 'ko'?value:record.detailCodeEngName}</div>),
        },
        {
            title: t('entrance.schedule.column29'),
            dataIndex: 'expenseAmount',
            key: 'expenseAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        
        {
            title: t('payment.cashflow.column1'),
            dataIndex: 'exceptionAmount',
            key: 'exceptionAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column2'),
            dataIndex: 'applyAmount',
            key: 'applyAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column3') + '(%)',
            dataIndex: 'salesRate',
            key: 'salesRate',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{value}</div>),
        },
    ];

    const getPnlColumns = (isExcel:boolean) => {
        const pnlColumns : TableColumnsType<ICashFlowPnL> = [
            {
                title: t('campus.shuttle.column4'),
                dataIndex: 'csType',
                key: 'csType',
                align: 'center',
                className: 'cashflowCsType',
                onCell: (record, index) => {
                    let tempRowCnt = 0;
                    let tempIndex = (index !== undefined) ? index + 1 : 0;
    
                    if(!pnlMode) {
                        tempRowCnt = cashFlowPnLInCnt1;
                        if(record.csType === t('payment.income.tab1')) {
                            return ({rowSpan: (tempIndex === 1) ? tempRowCnt : 0})
                        } else {
                            return ({rowSpan: (tempIndex === tempRowCnt + 1) ? cashFlowPnLExCnt1 : 0})
                        }
                    } else {
                        tempRowCnt = cashFlowPnLInCnt2;
                        if(record.csType === t('payment.income.tab1')) {
                            return ({rowSpan: (tempIndex === 1) ? tempRowCnt : 0})
                        } else {
                            return ({rowSpan: (tempIndex === tempRowCnt + 1) ? cashFlowPnLExCnt2 : 0})
                        }
                    }
                },
            },
            {
                title: isExcel ? t('payment.income.search2') : (
                    <>
                        {t('payment.income.search2')}
                        <button type="button" className={'btn-unfold ' + (!pnlMode?' ':'fold')} onClick={()=>{pnlModeChange()}}></button>
                    </>),
                dataIndex: 'accCodeName',
                key: 'accCodeName',
                align: 'left',
                className: 'cashflowBorderRight',
                render: (value,record) => (<div className={record.depth === 2 ? "ml-3" : ""}>{value}</div>),
                width: '250px'
            },
            {
                title: pnlYear + '/03',
                dataIndex: 'mo03',
                key: 'mo03',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/04',
                dataIndex: 'mo04',
                key: 'mo04',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/05',
                dataIndex: 'mo05',
                key: 'mo05',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/06',
                dataIndex: 'mo06',
                key: 'mo06',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/07',
                dataIndex: 'mo07',
                key: 'mo07',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/08',
                dataIndex: 'mo08',
                key: 'mo08',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/09',
                dataIndex: 'mo09',
                key: 'mo09',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/10',
                dataIndex: 'mo10',
                key: 'mo10',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/11',
                dataIndex: 'mo11',
                key: 'mo11',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlYear + '/12',
                dataIndex: 'mo12',
                key: 'mo12',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlNextYear + '/01',
                dataIndex: 'mo01',
                key: 'mo01',
                align: 'center',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: pnlNextYear + '/02',
                dataIndex: 'mo02',
                key: 'mo02',
                align: 'center',
                className: 'cashflowBorderRight',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
            {
                title: t('cbt.test.column22'),
                dataIndex: 'total',
                key: 'total',
                align: 'center',
                className: 'tTotal',
                render: value => (<div className='text-right ant-table-cell-ellipsis'>{(value || value === 0?'￦' + value.toLocaleString():'')}</div>),
            },
        ];
        return pnlColumns;
    }

    const dateColumns: TableColumnsType<ICashFlow> = [
        {
            title: t('payment.cashflow.column4'),
            dataIndex: 'dateSales',
            key: 'dateSales',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column5'),
            dataIndex: 'dateExpense',
            key: 'dateExpense',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        
        {
            title: t('payment.cashflow.column6'),
            dataIndex: 'dateNetIncome',
            key: 'exceptionAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column7'),
            dataIndex: 'dateUnpaid',
            key: 'dateUnpaid',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column8'),
            dataIndex: 'dateCash',
            key: 'dateCash',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column9'),
            dataIndex: 'exceptionAmount',
            key: 'exceptionAmount',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column10'),
            dataIndex: 'dateBalance',
            key: 'dateBalance',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{'￦' + (value?value.toLocaleString():'0')}</div>),
        },
        {
            title: t('payment.cashflow.column11'),
            dataIndex: 'incomeRate',
            key: 'incomeRate',
            align: 'center',
            render: value => (<div className='text-right ant-table-cell-ellipsis'>{value}</div>),
        },
    ];

    const pnlModeChange = () => {
        setPnlMode(!pnlMode);
    }

    const getColumns = () => {
        const columnList:any[] = [];
        columnList.push(inColumns);
        if(auth.hqYn === 'Y') {
            columnList.push(inColumns);
        }
        columnList.push(exColumns);
        columnList.push(dateColumns);
        columnList.push(getPnlColumns(true));
        return columnList;
    }

    const getData = () => {
        const dataList:any[] = [];
        dataList.push(incomeRefineCampus);
        if(auth.hqYn === 'Y') {
            dataList.push(incomeRefineHq);
        }
        dataList.push(expenseRefine);
        dataList.push(dateCashFlow);
        dataList.push(cashFlowPnLRefine2);
        return dataList;
    }

    const getSubTitle = () => {
        const subTitleList:any[] = [];
        subTitleList.push(t('payment.cashflow.label1') + '(' + t('campus.staff.option2') + ')');
        if(auth.hqYn === 'Y') {
            subTitleList.push(t('payment.cashflow.label1') + '(' + t('campus.staff.option1') + ')');
        }
        subTitleList.push(t('payment.cashflow.label2'));
        subTitleList.push(t('payment.cashflow.label3'));
        subTitleList.push(t('payment.cashflow.label4'));
        return subTitleList;
    }

    const onExportTable = () => {
        const currentDate = moment(new Date());
        

        let excelTitle = `${t('campus.staff.option2') + ' ' + t('payment.income.tab5')}`;
        let arrSubTitle = [];
        let campusNames = '';

        if(campusCodes) {
            if(campusCodes.length == 0) {
                campusNames = t('common.text.all');
            } else {
                campusCodes.forEach((item) => {
                if(campusNames != '') {
                    campusNames += ', '  
                }
                campusNames += campusData.find(campus => item == campus.campusCode)?.campusKorName;
                });
            }
        }
        
        arrSubTitle.push(t('common.excel.campus') + " : " + campusNames);
        arrSubTitle.push(t('common.excel.period') + " : " + '2024/09/04 ~ 2024/09/04');
        exportMultiTitleTable(
            getColumns(),
            getData(),
            `${excelTitle}_(${currentDate.format('YYYYMMDD')})`,
            `${t('student.student.column3')}`,
            [15, 12, 12, 15, 15, 15, 15, 15, 12, 10, 10],
            excelTitle, arrSubTitle,
            getSubTitle()
        );
    }

    return (
        <Block>
            {isLoading || isLoading2 || isLoading3 || isLoading4 ? <Loader /> : null}
            <div className="common-search">
                <div className="search-area">
                    <ul className="search-bx">
                        <li>
                            <label>{t('common.menu.campus')}</label> {/* 캠퍼스 */}
                            {
                                auth && (auth.hqYn === 'Y')
                                ? (
                                <>
                                    <SelectCampusMultiChoice
                                    placeholder={t('statistics.eLearning.title2')}
                                    onChange={setCampusCodes}
                                    value={campusCodes}
                                    />
                                    <label>
                                    ({campusCodes.length ? `${campusCodes.length}${t('statistics.attendance.text1')}` : t('common.text.all')})
                                    </label>
                                </>
                                )
                                : <SelectCampus />
                            }
                        </li>
                        <li className="period">
                            <label>{t('sms.list.column1')}</label> {/* 기간 */}
                            <div className="comm-btn__area">
                                <FinancialDatePicker
                                    setStartDate={setSrtDate}
                                    setEndDate={setEndDate}
                                    type={DateTableType.Simple}
                                    defSelType={defSelType}
                                    setDefSelType={setDefSelType}
                                />
                            </div>
                            <div className="date-picker__area">
                                <DatePicker
                                value={srtDate ? moment(srtDate) : undefined}
                                onChange={e => {
                                    if (e === null) setSrtDate('');
                                    else setSrtDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            ~
                            <div className="date-picker__area">
                                <DatePicker
                                value={endDate ? moment(endDate) : undefined}
                                onChange={e => {
                                    if (e === null) setEndDate('');
                                    else setEndDate(moment(e).format('YYYYMMDD'))
                                }}
                                format={['YYYY-MM-DD', 'YYYYMMDD']}
                                />
                            </div>
                            <div className="comm-btn__area">
                                <Button
                                    className="btn-basic small black"
                                    onClick={() => getAllListSearch()}
                                    text={t('common.button.search')}
                                />
                                <DownloadButton onClick={onExportTable} />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            {/* 수입 */}
            <div className="comm-bx__between">
                <div><h3 className='sub-title'>{t('payment.cashflow.label1') + '(' + t('campus.staff.option2') + ')'}</h3></div>
            </div>
            <div className="comm-table__area">
                <Table
                    columns={inColumns}
                    dataSource={incomeRefineCampus}
                    rowKey={'paymentTargetCode'}
                    rowClassName={(record: ICashFlowIncome) => record.paymentTargetCode === t('statistics.appday.column2') ? 'tTotal' : ''}
                />
            </div>
            {auth.hqYn === 'Y' && (
                <>
                    <div className="comm-bx__between">
                        <div><h3 className='sub-title'>{t('payment.cashflow.label1') + '(' + t('campus.staff.option1') + ')'}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <Table
                            columns={inColumns}
                            dataSource={incomeRefineHq}
                            rowKey={'paymentTargetCode'}
                            rowClassName={(record: ICashFlowIncome) => record.paymentTargetCode === t('statistics.appday.column2') ? 'tTotal' : ''}
                            pagination={{
                                current: 1,
                                pageSize: 99,
                            }}
                        />
                    </div>
                </>
            )}
            {/* 지출 */}
            <div className="comm-bx__between">
                <div><h3 className='sub-title'>{t('payment.cashflow.label2')}</h3></div>                
            </div>
            <div className="comm-table__area">
                <Table
                    columns={exColumns}
                    dataSource={expenseRefine}
                    rowKey={'expenseAccCode'}
                    rowClassName={(record: ICashFlowExpense) => record.expenseAccCode === '' ? 'tTotal' : ''}
                    pagination={{
                        current: 1,
                        pageSize: 99,
                    }}
                />
            </div>
            <div className="comm-bx__between">
                <div><h3 className='sub-title'>{t('payment.cashflow.label3')}</h3></div>                
            </div>
            <div className="comm-table__area">
                <Table
                    columns={dateColumns}
                    dataSource={dateCashFlow}
                    rowKey={'detailCodeName'}
                    pagination={{
                        current: 1,
                        pageSize: 99,
                    }}
                />
            </div>
            <div className="comm-bx__between" style={{justifyContent:'normal'}}>
                <div className="comm-sch_result"><h3 className='sub-title' style={{verticalAlign:'bottom'}}>{t('payment.cashflow.label4')}</h3></div>
            </div>
            <div className="comm-table__area table-cash-flow">
                <Table
                    columns={getPnlColumns(false)}
                    dataSource={(!pnlMode) ? cashFlowPnLRefine1 : cashFlowPnLRefine2} /* cashFlowPnL?.data */
                    rowClassName={(record: ICashFlowPnL) => 
                        record.depth === 4 ? ((record.csType === t('payment.income.tab1')) ? 'tTotal cashflowBorderBottom':'tTotal' )
                        : (record.depth === 1 || record.depth === 3) ? 'subtotal' : ''}
                    rowKey={'no'}
                    pagination={{
                        current: 1,
                        pageSize: 99,
                    }}
                    bordered
                />
            </div>
        </Block>
    )
}

export default CashFlowList;